






































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';
import { ProductIssueDetailsModule } from '@/store/Products/ProductIssueDetailsModule';
import ProductState from '@/components/Products/ProductState.vue';
import DepositBankSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/Banking/DepositBankSettingsRead.vue';
import LendingBankSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/Banking/LendingBankSettingsRead.vue';
import DepositCardSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/Cards/DepositCardSettingsRead.vue';
import LendingCardSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/Cards/LendingCardSettingsRead.vue';
import GeneralPayeeSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/GeneralPayee/GeneralPayeeSettingsRead.vue';
import DepositPaymentOrderSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/PaymentOrders/DepositPaymentOrderSettingsRead.vue';
import DepositInterestSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/DepositInterest/DepositInterestSettingsRead.vue';
import LendingInterestSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/LendingInterest/LendingInterestSettingsRead.vue';
import DepositInstantAccessSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/InstantAccess/DepositInstantAccessSettingsRead.vue';
import DepositOverdraftSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/Overdraft/DepositOverdraftSettingsRead.vue';
import DepositOverdraftInterestSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/OverdraftInterest/DepositOverdraftInterestSettingsRead.vue';
import DepositFixedTermSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/FixedTerm/DepositFixedTermSettingsRead.vue';
import DepositCoolingOffSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/CoolingOff/DepositCoolingOffSettingsRead.vue';
import LendingTermSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/Term/LendingTermSettingsRead.vue';
import DepositFixedTermMaturitySettingsRead from '@/components/Products/ProductSettings/DefaultSettings/FixedTermMaturity/DepositFixedTermMaturitySettingsRead.vue';
import LendingScheduleSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/Schedule/LendingScheduleSettingsRead.vue';
import LendingRepaymentPlansSettingsRead from '@/components/Products/ProductSettings/DefaultSettings/RepaymentPlans/LendingRepaymentPlansSettingsRead.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'DefaultSettingsTabs', components: {
    ProductState,
    DepositBankSettingsRead,
    LendingBankSettingsRead,
    DepositCardSettingsRead,
    LendingCardSettingsRead,
    GeneralPayeeSettingsRead,
    DepositPaymentOrderSettingsRead,
    DepositInterestSettingsRead,
    LendingInterestSettingsRead,
    DepositInstantAccessSettingsRead,
    DepositOverdraftSettingsRead,
    DepositOverdraftInterestSettingsRead,
    DepositFixedTermSettingsRead,
    DepositCoolingOffSettingsRead,
    LendingTermSettingsRead,
    DepositFixedTermMaturitySettingsRead,
    LendingScheduleSettingsRead,
    LendingRepaymentPlansSettingsRead
} })
export default class extends SaascadaVue {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;

    @Prop({required: true})
    entityType: EntityType;

    tabIndex = 0;

    get product() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.product;
        }
        return ProductIssueDetailsModule.productIssue;
    }

    get visibility() {
        if (this.entityType === EntityType.Product) {
            return ProductDetailsModule.productFeatureVisibility;
        }
        return ProductIssueDetailsModule.productFeatureVisibility;
    }

}
